import React, { useCallback } from 'react'

import { FILTER_NAME } from 'Pods/SearchPage/Shared/Tracking/constants'
import { useTrackFilterSelect } from 'Pods/SearchPage/Shared/Tracking/FilterTracking'
import useTranslate from 'Pods/SearchPage/Shared/useTranslate'
import { setPersonalFilter } from 'Pods/SearchPage/Store/actions/moreFilters'
import { PERSONAL_FILTER } from 'Pods/SearchPage/Store/constants'
import { useSearchPageStore } from 'Pods/SearchPage/Store/index'

import FilterChip from '../../../Shared/FilterChip/FilterChip'

function WishListChip() {
  const translate = useTranslate()

  const isChecked = useSearchPageStore(state => state.personalFilter === PERSONAL_FILTER.WISH_LIST_ONLY)
  const trackFilterSelect = useTrackFilterSelect()

  const handleChange = useCallback((nextChecked) => {
    if (nextChecked) trackFilterSelect(FILTER_NAME.PERSONAL, PERSONAL_FILTER.WISH_LIST_ONLY)
    setPersonalFilter(nextChecked ? PERSONAL_FILTER.WISH_LIST_ONLY : undefined)
  }, [trackFilterSelect])

  return (
    <FilterChip
      id="quick-filter-wish_list"
      label={translate('search_page.filters.quick_filters.in_my_wish_list')}
      isChecked={isChecked}
      onChange={handleChange}
    />
  )
}

export default WishListChip
